import { render, staticRenderFns } from "./Reklama.vue?vue&type=template&id=46fcf9c4&scoped=true&"
import script from "./Reklama.vue?vue&type=script&lang=js&"
export * from "./Reklama.vue?vue&type=script&lang=js&"
import style0 from "./Reklama.vue?vue&type=style&index=0&id=46fcf9c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fcf9c4",
  null
  
)

export default component.exports